import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, GridItem } from '@chakra-ui/react';
import { Svg } from '../../base';
const ToastMsgFC = ({ data }) => {
    return (_jsxs(Grid, { gap: '8px', gridTemplateColumns: '20px 1fr', color: '{colors.white}', alignItems: 'center', children: [_jsx(GridItem, { children: _jsx(Svg, { name: data.icon ?? 'Warn', size: 's20' }) }), _jsx(GridItem, { children: data.message })] }));
};
export const ToastMsg = ToastMsgFC;
//# sourceMappingURL=ToastMsg.js.map